import { FC } from 'react';
import { Box, Button, CircularProgress, TextField, useTheme } from '@mui/material';
import { genericTexts } from '@utils/translations/en';

interface AddClientCodeFormProps {
  value: string;
  onChange: (value: string) => void;
  onSave: () => void;
  onCancel: () => void;
  isDuplicate: boolean;
  isLoading: boolean;
}

const AddClientCodeForm: FC<AddClientCodeFormProps> = ({
  value,
  onChange,
  onSave,
  onCancel,
  isDuplicate,
  isLoading,
}) => {
  const theme = useTheme();
  const borderColor = isDuplicate ? theme.palette.error.main : theme.palette.primary.main;

  return (
    <Box sx={{ mb: '0.75rem' }}>
      <TextField
        label="Enter Client Code"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        error={isDuplicate}
        helperText={isDuplicate ? 'Client Code already exists' : undefined}
        fullWidth
        size="medium"
        sx={{
          '& .MuiInputLabel-root.Mui-focused': { color: borderColor },
          '& .MuiOutlinedInput-root': {
            '& fieldset': { borderColor },
            '&:hover fieldset': { borderColor },
            '&.Mui-focused fieldset': { borderColor },
          },
        }}
      />
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, pt: '0.5rem' }}>
        <Button
          variant="contained"
          onClick={onSave}
          disabled={!value || isDuplicate || isLoading}
          startIcon={isLoading ? <CircularProgress size={14} color="inherit" /> : undefined}
          sx={{
            borderRadius: '100px',
            textTransform: 'none',
            px: '1.5rem',
            background: theme.palette.primary.main,
            '&:hover': { background: theme.palette.primary.main },
          }}
        >
          {genericTexts.Save}
        </Button>
        <Button
          onClick={onCancel}
          sx={{ borderRadius: '100px', textTransform: 'none', color: theme.palette.primary.main }}
        >
          {genericTexts.Cancel}
        </Button>
      </Box>
    </Box>
  );
};

export default AddClientCodeForm;
